import React from 'react';

export const ViewFull = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.66471C10 2.29652 10.2985 1.99805 10.6667 1.99805H13.3333C13.7015 1.99805 14 2.29652 14 2.66471V5.33138C14 5.69957 13.7015 5.99805 13.3333 5.99805C12.9651 5.99805 12.6667 5.69957 12.6667 5.33138V3.33138H10.6667C10.2985 3.33138 10 3.0329 10 2.66471Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8047 2.19331C14.0651 2.45366 14.0651 2.87577 13.8047 3.13612L9.80474 7.13612C9.54439 7.39647 9.12228 7.39647 8.86193 7.13612C8.60158 6.87577 8.60158 6.45366 8.86193 6.19331L12.8619 2.19331C13.1223 1.93296 13.5444 1.93296 13.8047 2.19331Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66667 9.99805C3.03486 9.99805 3.33333 10.2965 3.33333 10.6647V12.6647H5.33333C5.70152 12.6647 6 12.9632 6 13.3314C6 13.6996 5.70152 13.998 5.33333 13.998H2.66667C2.29848 13.998 2 13.6996 2 13.3314V10.6647C2 10.2965 2.29848 9.99805 2.66667 9.99805Z"
      fill="#6B7280"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.13807 8.86497C7.39842 9.12532 7.39842 9.54743 7.13807 9.80778L3.13807 13.8078C2.87772 14.0681 2.45561 14.0681 2.19526 13.8078C1.93491 13.5474 1.93491 13.1253 2.19526 12.865L6.19526 8.86497C6.45561 8.60462 6.87772 8.60462 7.13807 8.86497Z"
      fill="#6B7280"
    />
  </svg>
);
